var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareActivity',{attrs:{"auth":_vm.auth},on:{"navigate":function($event){return _vm.$emit('navigate', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }